export const iconFontAwesomeBuildingsToriiGate = (
	<i className="fa-solid fa-torii-gate"></i>
);
